import { useEffect, useState } from 'react';

// Returns how many items fit for the current viewport. `breakpoints` is a list
// of { query, count } checked in order; the first matching media query wins,
// otherwise `fallback` is used. Only re-renders when a breakpoint is crossed.
const getCount = (breakpoints, fallback) => {
  if (typeof window === 'undefined' || !window.matchMedia) return fallback;
  const match = breakpoints.find(({ query }) => window.matchMedia(query).matches);
  return match ? match.count : fallback;
};

const useVisibleCount = (breakpoints, fallback) => {
  const [count, setCount] = useState(() => getCount(breakpoints, fallback));

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;

    const update = () => setCount(getCount(breakpoints, fallback));
    const mediaQueries = breakpoints.map(({ query }) => window.matchMedia(query));

    mediaQueries.forEach((mq) => mq.addEventListener('change', update));
    update();

    return () => {
      mediaQueries.forEach((mq) => mq.removeEventListener('change', update));
    };
  }, [breakpoints, fallback]);

  return count;
};

export default useVisibleCount;
